import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type GetPartsDriversQueryVariables = Types.Exact<{
  customerId: Types.Scalars['bigint']['input'];
}>;


export type GetPartsDriversQuery = { __typename?: 'query_root', drivers: Array<{ __typename?: 'drivers', id: number, status: string, user?: { __typename?: 'users', id: number, display_name: string, avatar_url?: string | null, email?: string | null, phone?: string | null } | null }> };


export const GetPartsDriversDocument = gql`
    query GetPartsDrivers($customerId: bigint!) {
  drivers(
    where: {config: {_contains: {attributes: {mobility_parts: true}}}, user: {users_usertocustomers: {customer_id: {_eq: $customerId}}, users_usertoroles: {roletype: {name: {_eq: "driver"}}}, active: {_eq: true}}}
    order_by: {user: {display_name: asc}}
  ) {
    id
    status
    user {
      id
      display_name
      avatar_url
      email
      phone
    }
  }
}
    `;

/**
 * __useGetPartsDriversQuery__
 *
 * To run a query within a React component, call `useGetPartsDriversQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetPartsDriversQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetPartsDriversQuery({
 *   variables: {
 *      customerId: // value for 'customerId'
 *   },
 * });
 */
export function useGetPartsDriversQuery(baseOptions: Apollo.QueryHookOptions<GetPartsDriversQuery, GetPartsDriversQueryVariables> & ({ variables: GetPartsDriversQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetPartsDriversQuery, GetPartsDriversQueryVariables>(GetPartsDriversDocument, options);
      }
export function useGetPartsDriversLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetPartsDriversQuery, GetPartsDriversQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetPartsDriversQuery, GetPartsDriversQueryVariables>(GetPartsDriversDocument, options);
        }
// @ts-ignore
export function useGetPartsDriversSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetPartsDriversQuery, GetPartsDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDriversQuery, GetPartsDriversQueryVariables>;
export function useGetPartsDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDriversQuery, GetPartsDriversQueryVariables>): Apollo.UseSuspenseQueryResult<GetPartsDriversQuery | undefined, GetPartsDriversQueryVariables>;
export function useGetPartsDriversSuspenseQuery(baseOptions?: Apollo.SkipToken | Apollo.SuspenseQueryHookOptions<GetPartsDriversQuery, GetPartsDriversQueryVariables>) {
          const options = baseOptions === Apollo.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetPartsDriversQuery, GetPartsDriversQueryVariables>(GetPartsDriversDocument, options);
        }
export type GetPartsDriversQueryHookResult = ReturnType<typeof useGetPartsDriversQuery>;
export type GetPartsDriversLazyQueryHookResult = ReturnType<typeof useGetPartsDriversLazyQuery>;
export type GetPartsDriversSuspenseQueryHookResult = ReturnType<typeof useGetPartsDriversSuspenseQuery>;
export type GetPartsDriversQueryResult = Apollo.QueryResult<GetPartsDriversQuery, GetPartsDriversQueryVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/partsDelivery/queries/getPartsDrivers.query.gql}
 */
export async function getPartsDrivers(
  variables: GetPartsDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<GetPartsDriversQuery['drivers']>
export async function getPartsDrivers(
  variables: GetPartsDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<GetPartsDriversQuery>
export async function getPartsDrivers(
  variables: GetPartsDriversQueryVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<GetPartsDriversQuery['drivers'] | GetPartsDriversQuery> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).query<GetPartsDriversQuery>(
    GetPartsDriversDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.drivers
}